const AUTH_TOKEN = 'authToken';
export default AUTH_TOKEN;
